import { render, staticRenderFns } from "./UserGroupCreate.vue?vue&type=template&id=018f1e22&scoped=true"
import script from "./UserGroupCreate.vue?vue&type=script&lang=js"
export * from "./UserGroupCreate.vue?vue&type=script&lang=js"
import style0 from "./UserGroupCreate.vue?vue&type=style&index=0&id=018f1e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018f1e22",
  null
  
)

export default component.exports